import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from './HeroSection';
import EmiSection from './EmiSection';
import EmiInfoSection from './EmiInfoSection';
import EmiCardsSection from './EmiCardsSection';
import usePageTitle from '../../hooks/UsePageTitle';

const EmiPage = () => {
    const { t } = useTranslation('homepage');
    const someProductTypeValue = "Personal Loan";
    usePageTitle(t('emi-page-title'));
  return (
    <>
      <HeroSection />
      <EmiSection productType={someProductTypeValue} />
     
      <EmiInfoSection />
      <EmiCardsSection />
    </>
  );
};

export default EmiPage;